import { apiRequest } from '@/utils/api-request';

export const revokeUserPat = async (tokenId: string): Promise<void> => {
  const response = await apiRequest({
    url: `/api-tokens/${encodeURIComponent(tokenId)}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(
      response.detail || 'Failed to revoke personal access token',
    );
  }
};
